// extracted by mini-css-extract-plugin
module.exports = {"popOverlay":"_3QyifGF7HqV_qfK4EjhLM4","contentContainer":"_2YYsEgnmsCX-ynPdLsNC4N","closeElement":"_1OQssy7ggesLRteY7vsvIy","closeIcon":"sAbWjsYD20c4vRCTD1Isk"};